// extracted by mini-css-extract-plugin
export default {"wrapper":"cD-z","viewport":"dD-z","container":"eD-z","slide":"fD-z"};